var _style, _g, _g2, _g3, _g4, _g5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscoAppDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ei6xbHo0aCV1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 480 240",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n#ei6xbHo0aCV2 {animation: ei6xbHo0aCV2_c_o 10000ms linear infinite normal forwards}@keyframes ei6xbHo0aCV2_c_o { 0% {opacity: 0} 65% {opacity: 0} 75% {opacity: 1} 85% {opacity: 0} 100% {opacity: 0}} #ei6xbHo0aCV15 {animation: ei6xbHo0aCV15_c_o 10000ms linear infinite normal forwards}@keyframes ei6xbHo0aCV15_c_o { 0% {opacity: 0} 45% {opacity: 0} 55% {opacity: 1} 65% {opacity: 0} 100% {opacity: 0}} #ei6xbHo0aCV25 {animation: ei6xbHo0aCV25_c_o 10000ms linear infinite normal forwards}@keyframes ei6xbHo0aCV25_c_o { 0% {opacity: 0} 25% {opacity: 0} 35% {opacity: 1} 45% {opacity: 0} 100% {opacity: 0}} #ei6xbHo0aCV37 {animation: ei6xbHo0aCV37_c_o 10000ms linear infinite normal forwards}@keyframes ei6xbHo0aCV37_c_o { 0% {opacity: 0} 5% {opacity: 0} 15% {opacity: 1} 25% {opacity: 0} 100% {opacity: 0}} #ei6xbHo0aCV47_to {animation: ei6xbHo0aCV47_to__to 10000ms linear infinite normal forwards}@keyframes ei6xbHo0aCV47_to__to { 0% {transform: translate(390.826279px,136.87014px)} 10% {transform: translate(294.588974px,165.132851px)} 20% {transform: translate(390.826279px,136.87014px)} 30% {transform: translate(294.588974px,165.132851px)} 40% {transform: translate(390.826279px,136.87014px)} 50% {transform: translate(294.588974px,165.132851px)} 60% {transform: translate(390.826279px,136.87014px)} 70% {transform: translate(294.588974px,165.132851px)} 80% {transform: translate(390.826279px,136.87014px)} 90% {transform: translate(294.588974px,165.132851px)} 100% {transform: translate(390.826279px,136.87014px)}}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ei6xbHo0aCV2",
    transform: "translate(0-408)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 120,
    rx: 8,
    ry: 8,
    transform: "translate(60 468)",
    fill: "#40434A"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 11,
    rx: 2,
    ry: 2,
    transform: "translate(180 500)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 11,
    rx: 2,
    ry: 2,
    transform: "translate(180 545)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ei6xbHo0aCV13)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M113.354,519.997l.001-.002l11.756,7.067l7.005-2.959c1.423-.617,2.958-.934,4.509-.932.258,0,.514.011.768.029-.842-3.296-2.62-6.275-5.118-8.576-2.497-2.3-5.607-3.823-8.951-4.384s-6.778-.134-9.885,1.227c-3.108,1.361-5.754,3.598-7.618,6.44.06-.001.119-.005.179-.005c2.598-.003,5.145.723,7.354,2.095Z",
    fill: "#0364b8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.355,519.995l-.001.002c-2.209-1.373-4.756-2.098-7.354-2.095-.06,0-.119.004-.179.005-2.543.031-5.029.758-7.1915,2.101s-3.9194,3.252-5.0819,5.522c-1.1624,2.269-1.6866,4.814-1.5161,7.36.1705,2.547,1.0292,4.998,2.4838,7.091l10.3667-4.377l4.609-1.947l10.261-4.333l5.359-2.263-11.756-7.066Z",
    fill: "#0078d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.393,523.199c-.254-.017-.51-.028-.768-.028-1.551-.002-3.085.316-4.509.934l-7.005,2.956l2.031,1.221l6.659,4.003l2.905,1.746l9.933,5.971c.903-1.682,1.371-3.563,1.361-5.473s-.497-3.787-1.417-5.459c-.921-1.672-2.244-3.085-3.849-4.111-1.606-1.026-3.442-1.631-5.341-1.76Z",
    fill: "#1490df"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.706,534.031l-2.905-1.746-6.659-4.002-2.031-1.221-5.359,2.262-10.261,4.333-4.609,1.947-10.3667,4.377c1.2883,1.859,3.0057,3.377,5.0056,4.425c2.0001,1.048,4.2231,1.595,6.4791,1.594h30.625c2.053.001,4.069-.557,5.832-1.613s3.208-2.571,4.182-4.385l-9.933-5.971Z",
    fill: "#28a8ea"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ei6xbHo0aCV13"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 36,
    rx: 0,
    ry: 0,
    transform: "translate(92 510)",
    fill: "#fff"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "ei6xbHo0aCV15",
    transform: "translate(0-272)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 120,
    rx: 8,
    ry: 8,
    transform: "translate(60 332)",
    fill: "#40434A"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 11,
    rx: 2,
    ry: 2,
    transform: "translate(180 364)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 208,
    height: 11,
    rx: 2,
    ry: 2,
    transform: "translate(180 409)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ei6xbHo0aCV23)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M137.594,389.898c.214.382.284.816.308,1.304l.03.65v4.548l.031.652c.062,1.063.821,1.849,1.859,1.916l.627.032v-7.148l.031-.65c.025-.483.095-.925.312-1.309.222-.394.54-.721.922-.948.383-.227.816-.346,1.257-.345.441,0,.875.121,1.256.35.382.228.699.556.919.951.214.382.281.824.306,1.301l.031.648v4.55l.032.652c.064,1.068.817,1.854,1.858,1.916L148,399v-7.798c0-1.379-.53-2.701-1.474-3.677-.944-.975-2.224-1.523-3.558-1.524-.715,0-1.421.156-2.072.46s-1.232.748-1.704,1.302c-.472-.554-1.053-.998-1.704-1.302s-1.357-.461-2.072-.46c-1.045,0-2.015.327-2.818.893-.49-.565-1.587-.893-2.217-.893v12.999l.63-.032c1.053-.072,1.814-.837,1.855-1.916l.034-.652v-4.548l.031-.65c.026-.491.092-.922.307-1.306.222-.394.539-.721.922-.948.382-.228.815-.347,1.256-.348.442,0,.875.12,1.257.348.383.228.7.556.921.95Zm-43.0775,9.071l.6296.031h9.4379l-.031-.648c-.085-1.069-.818-1.85-1.856-1.92l-.63-.032h-5.6616l7.5486-7.8-.031-.648c-.049-1.08-.812-1.86-1.856-1.919l-.629-.03L92,386.001l.0311.65c.0825,1.059.8258,1.856,1.8551,1.917l.6303.032h5.6615l-7.5484,7.801.0311.651c.0621,1.071.8106,1.847,1.8558,1.916v.001Zm33.3945-11.066c.584.604,1.048,1.321,1.364,2.109.316.789.479,1.634.479,2.488c0,.853-.163,1.699-.479,2.487-.316.789-.78,1.505-1.364,2.109-1.181,1.218-2.781,1.903-4.45,1.903s-3.27-.685-4.451-1.903c-2.457-2.538-2.457-6.654,0-9.193.584-.603,1.277-1.082,2.04-1.408.763-.327,1.581-.495,2.407-.495.827-.001,1.646.167,2.41.494.765.327,1.459.806,2.044,1.41v-.001Zm-1.781,1.841c.708.732,1.106,1.724,1.106,2.758s-.398,2.026-1.106,2.758c-.708.731-1.668,1.142-2.669,1.142-1.002,0-1.962-.411-2.67-1.142-.708-.732-1.105-1.724-1.105-2.758s.397-2.026,1.105-2.758c.708-.731,1.668-1.142,2.67-1.142c1.001,0,1.961.411,2.669,1.142ZM110.251,386c.826,0,1.644.168,2.407.495s1.456.806,2.039,1.409c2.458,2.538,2.458,6.654,0,9.192-1.18,1.218-2.781,1.903-4.45,1.903s-3.27-.685-4.45-1.903c-2.457-2.538-2.457-6.654,0-9.193.584-.603,1.277-1.082,2.04-1.408.763-.327,1.58-.495,2.406-.495h.008Zm2.666,3.743c.708.731,1.106,1.724,1.106,2.758s-.398,2.027-1.106,2.758-1.669,1.142-2.67,1.142-1.961-.411-2.67-1.142c-.707-.731-1.105-1.723-1.105-2.758c0-1.034.398-2.026,1.105-2.758.709-.731,1.669-1.141,2.67-1.141s1.962.41,2.67,1.141v0Z",
    clipRule: "evenodd",
    fill: "#2d8cff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ei6xbHo0aCV23"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 13,
    rx: 0,
    ry: 0,
    transform: "translate(92 386)",
    fill: "#fff"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "ei6xbHo0aCV25",
    transform: "translate(0-136)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 120,
    rx: 8,
    ry: 8,
    transform: "translate(60 196)",
    fill: "#40434A"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 208,
    height: 11,
    rx: 2,
    ry: 2,
    transform: "translate(180 228)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 208,
    height: 11,
    rx: 2,
    ry: 2,
    transform: "translate(180 273)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ei6xbHo0aCV35)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M147.897,228.079h-55.8608v55.861h55.8608v-55.861Z",
    fill: "#d5ff00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.134,270.756h-40.3431v5.429h40.3431v-5.429Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.97,267.646l3.841-3.833l11.677-11.685-3.885-3.878-8.919,8.926v-22.117h-5.436l.007,22.117-8.926-8.926-3.877,3.878l11.677,11.685l3.841,3.833Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ei6xbHo0aCV35"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 0,
    ry: 0,
    transform: "translate(92 228)",
    fill: "#fff"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "ei6xbHo0aCV37",
    opacity: 0
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 120,
    rx: 8,
    ry: 8,
    transform: "translate(60 60)",
    fill: "#40434A"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 208,
    height: 11,
    rx: 2,
    ry: 2,
    transform: "translate(180 92)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 174,
    height: 11,
    rx: 2,
    ry: 2,
    transform: "translate(180 137)",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.001,133.999c7.732,0,14-6.268,14-14.001c0-7.732-6.268-14-14-14-7.733,0-14.001,6.268-14.001,14c0,7.733,6.268,14.001,14.001,14.001Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.875,127.002L95.7524,106.004c-2.4581,4.257-3.7524,9.085-3.7524,14c0,4.916,1.2937,9.744,3.7516,14c2.4578,4.257,5.9934,7.791,10.2494,10.248c4.257,2.457,9.086,3.749,14.001,3.748l12.123-20.998v-.003c-1.227,2.129-2.995,3.898-5.123,5.128-2.128,1.229-4.543,1.877-7.001,1.877-2.457,0-4.872-.646-7.001-1.875-2.128-1.229-3.896-2.997-5.125-5.126v-.001Z",
    fill: "#229342"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.125,127.001l-12.123,20.998c4.915.001,9.743-1.293,14-3.75s7.791-5.992,10.248-10.249c2.458-4.257,3.751-9.086,3.75-14.001s-1.296-9.743-3.755-13.999L120,106l-.003.002c2.458-.001,4.873.645,7.002,1.873c2.129,1.229,3.897,2.996,5.126,5.124c1.229,2.129,1.877,4.543,1.877,7.001-.001,2.458-.648,4.873-1.877,7.002v-.001Z",
    fill: "#fbc116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.001,131.086c6.121,0,11.083-4.963,11.083-11.085c0-6.121-4.962-11.084-11.083-11.084-6.122,0-11.084,4.963-11.084,11.084c0,6.122,4.962,11.085,11.084,11.085Z",
    fill: "#1a73e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.001,106.001h24.245c-2.457-4.257-5.991-7.7922-10.247-10.25-4.257-2.4577-9.085-3.7514-14-3.751-4.916.0003-9.744,1.2946-14,3.753-4.256,2.4583-7.7899,5.994-10.2463,10.251l12.1233,20.998.003.002c-1.23-2.128-1.878-4.543-1.879-7.001s.646-4.873,1.875-7.002c1.228-2.129,2.996-3.896,5.125-5.125c2.128-1.229,4.543-1.876,7.001-1.875v0Z",
    fill: "#e33b2e"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "ei6xbHo0aCV47_to",
    transform: "translate(390.826279,136.87014)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-370.826279,-156.87014)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M405.625,178.5h-6.913l-2.45-2.363c5.469-6.352,9.465-13.835,11.704-21.913s2.664-16.55,1.246-24.812C405.1,105.087,384.8,85.6624,360.3,82.6874c-8.613-1.0897-17.362-.1945-25.576,2.617-8.214,2.8116-15.676,7.4649-21.815,13.604-6.14,6.1396-10.793,13.6016-13.604,21.8156-2.812,8.214-3.707,16.963-2.618,25.576c2.975,24.5,22.4,44.8,46.725,48.912c8.262,1.418,16.734.993,24.812-1.246s15.561-6.235,21.913-11.704l2.363,2.45v6.913l37.187,37.187c3.588,3.588,9.45,3.588,13.038,0c3.587-3.587,3.587-9.45,0-13.037l-37.1-37.275Zm-52.5,0c-21.788,0-39.375-17.588-39.375-39.375c0-21.788,17.587-39.3751,39.375-39.3751c21.787,0,39.375,17.5871,39.375,39.3751c0,21.787-17.588,39.375-39.375,39.375Z",
    fill: "#7A5CF2"
  })), /*#__PURE__*/React.createElement("circle", {
    r: 40,
    transform: "translate(353 139)",
    opacity: 0.25,
    fill: "#000000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscoAppDark);
export default __webpack_public_path__ + "static/media/disco-app-dark.2e956e17ce0ef6faabb447ec721e09fb.svg";
export { ForwardRef as ReactComponent };